<template>
  <div class="Advertisements">
    <div class="Advertisements__Header">
      <Header :title="$t('dashboard.advertisements')" />
    </div>
    <AdvertisementsMetrics />
    <div class="Advertisements__Grafic">
      <AdvertisementsAmount />
      <AdvertisementsStates />
    </div>
    <div class="Advertisements__Select">
      <FilterDisplay
        :options="sectors"
        :placeholder="placeholder"
        :value="value"
        class="filter"
      />
    </div>
    <filteredAdvertisementsData />
  </div>
</template>

<script>
import {
  Header,
  FilterDisplay,
  FilteredAdvertisementsData,
} from '@/components';
import { getDataToFilterAdvertisements } from '@/api';

import AdvertisementsMetrics from './AdvertisementsMetrics';
import AdvertisementsAmount from './AdvertisementsAmount';
import AdvertisementsStates from './AdvertisementsStates';

export default {
  name: 'Advertisements',
  data() {
    return {
      sectors: [],
      placeholder:this.$t('business.placeholder-sector'),
      title: this.$t('business.filter-sector'),
      value: {},
    };
  },
  components: {
    Header,
    AdvertisementsMetrics,
    AdvertisementsStates,
    AdvertisementsAmount,
    FilterDisplay,
    FilteredAdvertisementsData,
  },
  created() {
    getDataToFilterAdvertisements().then(
      data => {
        this.sectors = data.map(item => item);
      },
      err => {
        console.log('Fetch Error: ', err);
      }
    );
  },
};
</script>

<style lang="scss">
.Advertisements {
  width: 100%;
  height: 100%;
  &__Header {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  &__Grafic {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: rem(20);
    margin-bottom: rem(20);
  }
  &__Select {
    width: 25%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .filter {
      width: 50%;
    }
  }
}
</style>
